<template>
  <v-row>
    <!-- loader -->
    <v-col
      v-if="false"
      xs="12"
      sm="12"
      md="12"
      lg="10"
      cols="12"
    >
      <loader></loader>
    </v-col>
    <!-- новый заказ: категория + одиночный степпер либо групповой режим -->
    <v-col
      cols="12"
      xs="12"
      sm="12"
      md="9"
    >
      <v-stepper
        v-model="activeStep"
        vertical
        class="custom-header"
      >
        <v-form
          ref="orderForm"
          v-model="valid"
          lazy-validation
        >
          <!-- Step 1 -->
          <v-stepper-step
            :complete="activeStep > 1"
            step="1"
          >
            <div class="d-flex align-center">
              <span class="text--primary text-4xl font-weight-bold me-3">01</span>
              <div class="d-flex flex-column">
                <span class="text--primary text-sm font-weight-semibold">{{ $t('Информация о музее') }}</span>
                <span class="text--secondary text-xs">{{ $t('Выберите категорию группы (РФ или ИГ), музей, дату и время') }}</span>
              </div>
            </div>
          </v-stepper-step>

          <v-stepper-content step="1">
            <v-row>
              <v-col
                cols="12"
              >
                <v-select
                  v-model="order.type"
                  :items="typeList[getFormatedLocale()]"
                  :rules="[v => !!v || $t('Выберите категорию группы')]"
                  :label="$t('Выберите категорию группы')"
                  required
                  item-text="name"
                  item-value="value"
                  hide-details="auto"
                  class="mb-4 mt-2"
                  outlined
                  dense
                  @change="onCategoryChange"
                ></v-select>

                <!-- Школьная группа (12.10.2026): категория группы остаётся
                     прежней, но стоимость считается по школьному прайс-листу, а
                     в примечание для оператора встаёт пометка. Действует и на
                     множественную заявку ниже. -->
                <v-checkbox
                  v-if="order.type !== 'all'"
                  v-model="order.school"
                  hide-details
                  dense
                  class="mt-0 mb-4"
                  :label="$t('Школьная группа')"
                ></v-checkbox>

                <!-- Множественная заявка «несколько музеев на одну группу».
                     Доступна всем категориям групп; включённая галочка
                     разворачивает групповую форму прямо здесь, вместо выбора
                     одного музея, а шаги 02–04 не показываются. -->
                <v-checkbox
                  v-if="isGroupModeAllowed"
                  v-model="multiRequest"
                  hide-details
                  dense
                  class="mt-0 mb-6"
                  :label="$t('Подать множественную заявку (несколько музеев на одну группу)')"
                ></v-checkbox>

                <new-request-group
                  v-if="isGroupMode"
                  :key="order.type"
                  :base-type="order.type"
                  :school="order.school"
                ></new-request-group>

                <template v-else>
                  <v-select
                    v-model="order.museum"
                    :items="filteredMuseumsList"
                    :rules="[v => !!v || $t('Выберите музей')]"
                    :label="$t('Выберите музей')"
                    required
                    :item-text="'name' + getFormatedLocale()"
                    item-value="id"
                    :no-data-text="$t('Ничего не найдено')"
                    hide-details="auto"
                    class="mb-6 mt-2"
                    outlined
                    dense
                    @change="fetchMuseumObjects(); museumSearch = ''"
                  >
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-content class="py-1">
                          <v-text-field
                            v-model="museumSearch"
                            :placeholder="$t('Поиск')"
                            outlined
                            dense
                            hide-details
                            clearable
                            @click.stop
                          ></v-text-field>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mb-1"></v-divider>
                    </template>
                  </v-select>

                  <v-select
                    v-if="order.museum"
                    v-model="order.museumObject"
                    :items="museumObjects"
                    :rules="[v => !!v || $t('Выберите объект')]"
                    :label="$t('Выберите объект')"
                    required
                    :item-text="'name' + getFormatedLocale()"
                    item-value="system_id"
                    hide-details="auto"
                    class="mb-2 mt-2"
                    outlined
                    dense
                    @change="setMuseumObject"
                  >
                  <!-- <template v-slot:item="slotProps">
                    {{ slotProps.item.name }}
                  </template> -->
                  </v-select>
                  <p
                    v-if="selectedMuseumObject.info_message !== ''"
                    class="caption"
                  >
                    {{ selectedMuseumObject.info_message }}
                  </p>
                  <div class="mt-4">
                    <!-- Дату показываем ту, что уйдёт в заявку. Раньше календарь
                         показывал сегодняшнюю, а в заявку шла самая ранняя
                         разрешённая (обычно завтрашняя), 07.10.2026. -->
                    <datepicker
                      v-if="order.museumObject"
                      :key="datepickerKey"
                      :date-value="order.date"
                      on-page="new-request-date"
                      :min-days-before="Number(selectedMuseumObject.min_days_before || 0)"
                      :days-off-dates="order.closedDay ? [] : (selectedMuseumObject['days_off_dates'] || [])"
                      :days-off="order.closedDay ? [] : (selectedMuseumObject['days_off'] || [])"
                      @newDate="handleDateChanges($event)"
                    ></datepicker>
                    <div v-if="order.museumObject">
                      <p class="caption mt-2 mb-1">
                        {{ $t('Если Вы хотите экскурсию в день, недоступный для выбора в календаре (выходной, праздничный) — поставьте галочку, календарь откроется. Действует специальный прайс. Наш менеджер свяжется с Вами и уточнит детали.') }}
                      </p>
                      <v-checkbox
                        v-model="order.closedDay"
                        hide-details
                        dense
                        class="mt-0 pt-0"
                        :label="$t('Да, хочу экскурсию в другой день')"
                        @change="onClosedDayToggle"
                      ></v-checkbox>
                    </div>
                  </div>

                  <v-select
                    v-if="order.museumObject && (order.date != todayLocal || sameDayAllowed)"
                    v-model="order.schedule"
                    :items="schedule"
                    :rules="[v => !!v || $t('Выберите время')]"
                    :label="$t('Выберите время')"
                    required
                    item-text="name"
                    item-value="id"
                    hide-details="auto"
                    class="mb-4 mt-4"
                    outlined
                    dense
                  ></v-select>
                  <!-- Кнопки действий держим справа — единое правило по всему кабинету. -->
                  <div class="mt-4 d-flex justify-end">
                    <v-btn
                      :disabled="order.schedule == null"
                      color="primary"
                      @click="activeStep = 2"
                    >
                      {{ $t('Далее') }}
                    </v-btn>
                  </div>
                </template>
              </v-col>
            </v-row>
          </v-stepper-content>

          <!-- Шаги 02–04 нужны только одиночной заявке: в групповом режиме всё
               заполняется внутри шага 01. -->
          <template v-if="!isGroupMode">
            <!-- Step 2 -->
            <v-stepper-step
              :complete="activeStep > 2"
              step="2"
            >
              <div class="d-flex align-center">
                <span class="text--primary text-4xl font-weight-bold me-3">02</span>
                <div class="d-flex flex-column">
                  <span class="text--primary text-sm font-weight-semibold">{{ $t('Информация о группе') }}</span>
                  <span class="text--secondary text-xs">{{ $t('Выберите кол-во билетов') }}</span>
                </div>
              </div>
            </v-stepper-step>

            <v-stepper-content step="2">
              <v-row>
                <v-col
                  cols="12"
                  md="9"
                >
                  <!-- У китайской группы страна не выбирается — всегда Китай. -->
                  <p
                    v-if="isChinaOrder"
                    class="text-sm mt-2 mb-6"
                  >
                    {{ $t('Страна') }}: <span class="font-weight-semibold">{{ $t('Китай') }}</span>
                  </p>
                  <p
                    v-else-if="isRuOrder"
                    class="text-sm mt-2 mb-6"
                  >
                    {{ $t('Страна') }}: <span class="font-weight-semibold">{{ $t('Россия') }}</span>
                  </p>
                  <v-select
                    v-else
                    v-model="order.country"
                    :items="filteredCountries"
                    :rules="[v => !!v || $t('Выберите страну')]"
                    :label="$t('Выберите страну')"
                    required
                    hide-details="auto"
                    item-text="name"
                    item-value="system_id"
                    :no-data-text="$t('Ничего не найдено')"
                    class="mt-2 mb-6"
                    outlined
                    dense
                    @change="countrySearch = ''"
                  >
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-content class="py-1">
                          <v-text-field
                            v-model="countrySearch"
                            :placeholder="$t('Поиск')"
                            outlined
                            dense
                            hide-details
                            clearable
                            @click.stop
                          ></v-text-field>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mb-1"></v-divider>
                    </template>
                  </v-select>
                  <v-text-field
                    v-for="kindOfTicket in selectedMuseumObject.tickets"
                    :id="kindOfTicket.internal_name"
                    :key="kindOfTicket.id"
                    v-model="order.tickets[kindOfTicket.internal_name]"
                    v-non-negative
                    type="number"
                    outlined
                    dense
                    class="mt-2 mb-2"
                    :label="kindOfTicket['name' + getFormatedLocale()]"
                    :hint="kindOfTicket['helper_text' + getFormatedLocale()]"
                    placeholder="0"
                    :rules="[validators.integerPositiveValidator]"
                    persistent-hint
                  >
                  </v-text-field>

                  <!-- Стоимость по прайс-листу из админки (09.10.2026): считает
                       сервер по объекту, дате и количествам. Объект не оценён —
                       строки нет, как и раньше. -->
                  <p
                    v-if="priceQuote.amount !== null && personsCount > 0"
                    class="text-sm mt-2 mb-0"
                  >
                    <span class="text--secondary">{{ $t('Стоимость по прайс-листу:') }} </span>
                    <span class="font-weight-semibold text--primary">{{ formatMoney(priceQuote.amount) }}</span>
                  </p>

                  <!-- persistent-hint -->
                  <!-- hint="До 18 лет" -->
                  <div
                    class="mt-4 d-flex flex-wrap justify-end"
                    style="gap: 8px"
                  >
                    <v-btn
                      outlined
                      @click="activeStep = 1"
                    >
                      {{ $t('Назад') }}
                    </v-btn>
                    <v-btn
                      color="primary"
                      :disabled="order.country == null || !valid || personsCount < 1"
                      @click="activeStep = 3"
                    >
                      {{ $t('Далее') }}
                    </v-btn>
                  </div>
                  <!-- Ноль билетов раньше уезжал в систему заявок и возвращался
                       голым «Неверные аргументы» — теперь дальше не пройти,
                       и написано почему. -->
                  <p
                    v-if="personsCount < 1"
                    class="caption mt-2 mb-0 text-right text--secondary"
                  >
                    {{ $t('Укажите количество билетов — хотя бы одно поле больше нуля') }}
                  </p>
                </v-col>
              </v-row>
            </v-stepper-content>

            <!-- Step 3 -->
            <v-stepper-step
              :complete="activeStep > 3"
              step="3"
            >
              <div class="d-flex align-center">
                <span class="text--primary text-4xl font-weight-bold me-3">03</span>
                <div class="d-flex flex-column">
                  <span class="text--primary text-sm font-weight-semibold">{{ $t('Доп. услуги') }}</span>
                  <span class="text--secondary text-xs">{{ $t('Выберите дополнительные услуги') }}</span>
                </div>
              </div>
            </v-stepper-step>

            <v-stepper-content step="3">
              <v-row>
                <v-col
                  :key="rerenderKey"
                  cols="12"
                  md="9"
                >
                  <!-- Та же подпись, что в «Расчёте стоимости» (шеф, 02.11.2026):
                       появляется, когда группа дошла до порога объекта. -->
                  <p
                    v-if="rgMandatory"
                    class="caption error--text font-weight-semibold"
                  >
                    {{ $t('При группе от {n} человек требуется радиогид', { n: rgThreshold }) }}
                  </p>
                  <v-checkbox
                    v-for="kindOfService in serviceOptions"
                    :id="kindOfService.internal_name"
                    :key="kindOfService.internal_name"
                    v-model="order.services[kindOfService.internal_name]"
                    :disabled="isServiceDisabled(kindOfService)"
                    hide-details
                    class="mt-2 mb-6"
                    @change="updateKey"
                  >
                    <template #label>
                      <div>
                        {{ kindOfService.is_fallback ? $t('Аудиогид') : kindOfService['name' + getFormatedLocale()] }}
                        <v-tooltip
                          v-if="!kindOfService.is_fallback && kindOfService['helper_text' + getFormatedLocale()]"
                          top
                        >
                          <template #activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              size="20"
                              class="ml-2 info--secondary"
                              v-on="on"
                            >
                              {{ icons.mdiHelpCircleOutline }}
                            </v-icon>
                          </template>
                          <span>{{ kindOfService['helper_text' + getFormatedLocale()] }}</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-checkbox>

                  <!-- Подпись и пояснение берём из карточки объекта в админке;
                       пусто — показываем формулировку по умолчанию. Количество
                       считается само по размеру группы (шеф, 17.10.2026): одно
                       обслуживание на группу до N человек, N — у объекта. -->
                  <v-text-field
                    v-if="selectedMuseumObject.is_additional_guide_field"
                    :value="order.guides"
                    readonly
                    outlined
                    dense
                    class="mt-2 mb-6"
                    :label="guideFieldText('additional_guide_label') || $t('Кол-во гидов сопровождающих (если нет лицензии)')"
                    :hint="autoGuidesHint"
                    persistent-hint
                    hide-details="auto"
                  ></v-text-field>

                  <div
                    class="d-flex flex-wrap justify-end"
                    style="gap: 8px"
                  >
                    <v-btn
                      outlined
                      @click="activeStep = 2"
                    >
                      {{ $t('Назад') }}
                    </v-btn>
                    <v-btn
                      color="primary"
                      @click="activeStep = 4"
                    >
                      {{ $t('Далее') }}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-stepper-content>

            <!-- Step 4 -->
            <v-stepper-step
              :complete="activeStep > 4"
              step="4"
            >
              <div class="d-flex align-center">
                <span class="text--primary text-4xl font-weight-bold me-3">04</span>
                <div class="d-flex flex-column">
                  <span class="text--primary text-sm font-weight-semibold">{{ $t('Доп. информация') }}</span>
                  <span class="text--secondary text-xs">{{ $t('Информация о гиде и пожелания') }}</span>
                </div>
              </div>
            </v-stepper-step>

            <v-stepper-content step="4">
              <v-row>
                <v-col
                  cols="12"
                  md="9"
                >
                  <v-text-field
                    v-model="order.refNumber"
                    type="text"
                    outlined
                    dense
                    class="mt-2 mb-6"
                    :label="$t('Ref номер (необязательно)')"
                    :placeholder="$t('Ref номер (необязательно)')"
                    :hint="$t('Уникальный номер группы / вспомогательный номер для ваших целей')"
                    persistent-hint
                    hide-details="auto"
                  ></v-text-field>
                  <v-text-field
                    v-model="order.guideName"
                    type="text"
                    outlined
                    dense
                    class="mt-2 mb-6"
                    :label="$t('Имя гида')"
                    :placeholder="$t('Имя гида')"
                    hide-details="auto"
                  ></v-text-field>
                  <v-text-field
                    v-model="order.guidePhone"
                    type="text"
                    outlined
                    dense
                    class="mt-2 mb-6"
                    :label="$t('Телефон гида')"
                    :placeholder="$t('Телефон гида')"
                    hide-details="auto"
                  ></v-text-field>
                  <!-- v-if="museumsList.filter(museum => museum.id == order.museum).hasOwnProperty('name') === 'Радиогид'" -->
                  <div
                    v-if="order.museumObject == 148"
                  >
                    <h4>
                      {{ $t('В поле "Пожелания" укажите:') }}<br><ul><li>{{ $t('адрес и время получения') }}</li><li>{{ $t('адрес и приблизительное время возврата оборудования') }}</li></ul>
                    </h4>
                    <br>
                  </div>
                  <v-textarea
                    v-model="order.comment"
                    :label="$t('Пожелания')"
                    rows="3"
                    outlined
                  ></v-textarea>
                  <p
                    v-if="priceQuote.amount !== null && personsCount > 0"
                    class="text-sm mb-4"
                  >
                    <span class="text--secondary">{{ $t('Стоимость по прайс-листу:') }} </span>
                    <span class="font-weight-semibold text--primary">{{ formatMoney(priceQuote.amount) }}</span>
                  </p>
                  <div
                    class="d-flex flex-wrap justify-end"
                    style="gap: 8px"
                  >
                    <v-btn
                      outlined
                      @click="activeStep = 3"
                    >
                      {{ $t('Назад') }}
                    </v-btn>
                    <v-btn
                      color="primary"
                      @click="sendOrder"
                    >
                      {{ $t('Отправить') }}
                    </v-btn>
                  </div>
                  <v-dialog
                    v-model="isSending"
                    overlay
                    persistent
                    width="300"
                  >
                    <v-card
                      color="primary"
                      dark
                    >
                      <v-card-text class="pt-3 white--text">
                        {{ $t('Пожалуйста, ожидайте') }}
                        <v-progress-linear
                          indeterminate
                          color="white"
                          class="mb-0 mt-2"
                        ></v-progress-linear>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                  <v-dialog
                    v-model="isShowMessage"
                    width="500"
                  >
                    <v-card>
                      <v-card-title v-if="isSuccess">
                        {{ $t('Успешно') }}
                      </v-card-title>
                      <v-card-title
                        v-else
                      >
                        {{ $t('Ошибка') }}
                      </v-card-title>

                      <v-card-text v-if="isSuccess">
                        {{ successMsg }}
                      </v-card-text>
                      <v-card-text v-else>
                        {{ errorMsg }}
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          v-if="isSuccess"
                          color="primary"
                          @click="closeMessageBoxAndRedirect"
                        >
                          {{ $t('Ок') }}
                        </v-btn>
                        <v-btn
                          v-else
                          color="error"
                          @click="closeMessageBox"
                        >
                          {{ $t('Ок') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-col>
              </v-row>
            </v-stepper-content>
          </template>
        </v-form>
      </v-stepper>
    </v-col>
  </v-row>
</template>

<script>
import Datepicker from '@/components/Datepicker.vue'
import Loader from '@/components/Loader.vue'
import axios from '@axios'
import store from '@/store'
import { useRouter } from '@core/utils'
import {
  earliestRequestDate, groupTypeChoices, guideServicesCount, toLocalDay,
} from '@/utils/helper'
import { integerPositiveValidator, required } from '@core/utils/validation'
import { mdiCalendar, mdiHelpCircleOutline } from '@mdi/js'
import { computed, ref, watch } from '@vue/composition-api'
import NewRequestGroup from './NewRequestGroup.vue'

export default {
  components: {
    Loader,
    Datepicker,
    NewRequestGroup,
  },
  setup(props, { root }) {
    const { router } = useRouter()
    const datepickerKey = ref(0)

    // ВАЖНО: перечисляем ВСЕ поля сразу, даже пустые.
    //
    // Vue 2 следит только за теми свойствами, которые были в объекте на момент
    // создания. Поля museum/museumObject/schedule/country дописывались позже —
    // и вёрстка про них не узнавала: кнопка «Далее» (:disabled="schedule == null")
    // оставалась серой после выбора времени и оживала лишь когда перерисовку
    // вызывало что-то другое — например повторный выбор даты. Отсюда жалобы
    // «не всегда работает, лечится повторным выбором даты».
    const order = ref({
      date: toLocalDay(),
      museum: null,
      museumObject: null,
      system_id: null,
      persons_per_guide: null,
      schedule: null,
      country: null,
      tickets: {},
      services: {},
      guides: '0',
      refNumber: '',
      guideName: '',
      guidePhone: '',
      comment: '',
      type: 'all',
      closedDay: false,
      school: false,
    })
    const rerenderKey = ref(1)
    const valid = ref(true)
    const orderForm = ref(null)

    // Именно ref: обычное число Vue не отслеживает, и отметка «шаг пройден»
    // (галочка в кружке у 01/02/03) обновлялась только при посторонней
    // перерисовке — та же болезнь, что была у кнопки «Далее».
    const activeStep = ref(1)
    const userData = JSON.parse(localStorage.getItem('userData'))

    const fetchMuseums = () => {
      store.dispatch('museums/fetchMuseums', order.value.type)
    }
    fetchMuseums()

    // Объекту разрешена подача «на сегодня» (в админке срок подачи = 0). Тогда
    // список времени показываем и для сегодняшней даты — иначе настройка была
    // мёртвой: календарь на сегодня пускал, а время выбрать было негде.
    const sameDayAllowed = computed(() => {
      const obj = store.getters['museumObjects/getSelectedMuseumObject'] || {}

      return Number(obj.min_days_before || 0) === 0
    })

    // Множественная заявка «несколько музеев на одну группу»: российские (ru),
    // иностранные (en) и китайские (cn) туристы. Галочка включает отдельный
    // компонент вместо степпера. При смене категории галочку сбрасываем — иначе
    // она «прилипнет». Категория 'all' (значение по умолчанию, пока клиент ничего
    // не выбрал) группового режима не имеет: непонятно, какие музеи показывать.
    const multiRequest = ref(false)
    const GROUP_MODE_TYPES = ['ru', 'en', 'cn']
    const isGroupModeAllowed = computed(() => GROUP_MODE_TYPES.includes(order.value.type))
    const isGroupMode = computed(() => multiRequest.value && isGroupModeAllowed.value)

    // У китайских туристов страна не выбирается — всегда Китай (system_id 100),
    // и в обычной заявке тоже, не только в групповой.
    const CHINA_COUNTRY_ID = 100
    const isChinaOrder = computed(() => order.value.type === 'cn')

    // У российских туристов страна не выбирается — всегда Россия (267):
    // раньше в списке были Россия и Беларусь, и выбор только путал.
    const RUSSIA_COUNTRY_ID = 267
    const isRuOrder = computed(() => order.value.type === 'ru')

    // Иностранные туристы.
    const isForeignOrder = computed(() => order.value.type === 'en')

    // Услуги, которые показываем на шаге «Доп. услуги». Обычно это услуги
    // объекта из справочника, но иностранным группам аудиогид предлагаем
    // всегда: в справочнике он привязан к четырём объектам, а спрашивают его
    // повсеместно. Так же сделано в групповой заявке.
    const serviceOptions = computed(() => {
      const obj = store.getters['museumObjects/getSelectedMuseumObject'] || {}
      const list = obj.services || []
      if (!isForeignOrder.value || list.some(item => item.internal_name === 'ag')) {
        return list
      }

      return [...list, { internal_name: 'ag', is_fallback: true }]
    })

    // Радиогид и аудиогид вместе не заказывают: отметил один — второй
    // недоступен. У объектов это задаётся настройкой service_logic; аудиогид
    // иностранным группам мы предлагаем сами, поэтому и запрет ставим сами.
    const isServiceDisabled = kindOfService => {
      const obj = store.getters['museumObjects/getSelectedMuseumObject'] || {}
      if (!obj.service_logic && !isForeignOrder.value) return false
      const services = order.value.services || {}
      if (kindOfService.internal_name === 'rg') return services.ag === true
      if (kindOfService.internal_name === 'ag') return services.rg === true

      return false
    }

    const onCategoryChange = () => {
      multiRequest.value = false

      // Не пустая строка, а null: кнопка «Далее» на шаге 2 открывается по
      // order.country == null, и с '' она разблокировалась бы без выбора страны.
      if (order.value.type === 'cn') order.value.country = CHINA_COUNTRY_ID
      else if (order.value.type === 'ru') order.value.country = RUSSIA_COUNTRY_ID
      else order.value.country = null

      // У каждой категории свой набор музеев, поэтому всё выбранное ниже
      // сбрасываем. Раньше оставалось: список музеев обновлялся, а в форме висел
      // объект от прежней категории — и с ним можно было уйти дальше по шагам.
      order.value.museum = null
      order.value.museumObject = null
      order.value.system_id = null
      order.value.persons_per_guide = null
      order.value.schedule = null
      order.value.tickets = {}
      order.value.services = {}
      order.value.closedDay = false
      order.value.date = toLocalDay()
      activeStep.value = 1
      datepickerKey.value += 1
      store.commit('museumObjects/init_selected_museum_object')

      fetchMuseums()
    }

    const fetchMuseumObjects = () => {
      store.dispatch('museumObjects/fetchMuseumObjects', [order.value.museum, order.value.type])
    }

    const fetchSchedule = () => {
      const formData = {
        date: order.value.date,
        museumObjectId: order.value.museumObject,
      }
      store.dispatch('schedule/fetchSchedule', formData)
    }

    // Страны объекта задают в админке («Поддерживаемые страны»). У части
    // объектов список пуст (07.10.2026: «Ораниенбаум — Парк», «Александро-
    // Невская лавра»), и иностранной группе там нечего было выбрать — дальше
    // шага 02 не пройти. Пустой список — ограничений нет: все страны, как в
    // групповой заявке.
    store.dispatch('countries/fetchCountries')
    const countriesOf = selectedMuseumObject => {
      const own = (selectedMuseumObject && selectedMuseumObject.countries) || []

      return own.length ? own : (store.getters['countries/getCountries'] || [])
    }

    // Страна из настроек клиента — если она есть у выбранного объекта.
    //
    // Раньше здесь было countryByName[0].system_id без проверки: когда страны
    // клиента нет в списке объекта (а такое у 40% объектов), код падал прямо
    // внутри .then(), ошибка глохла, и страна просто не подставлялась — жалоба
    // «у клиента не выбиралась страна». Возвращаем null, а не пустую строку:
    // кнопка «Далее» на шаге 02 открывается по country == null, и с пустой
    // строкой она пустила бы дальше вообще без страны.
    const getCountryByUserValue = selectedMuseumObject => {
      const wanted = userData.default_guide_country
      if (!wanted) return null

      const countries = countriesOf(selectedMuseumObject)
      const match = countries.find(item => item.name === wanted)

      return match ? match.system_id : null
    }

    const setMuseumObject = id => {
        datepickerKey.value += 1
        store.dispatch('museumObjects/setSelectedMuseumObject', id).then(selectedMuseumObject => {
            // Собираем новые объекты целиком, а не дописываем ключи в старые:
            // ключи, добавленные к уже созданному объекту, Vue 2 не отслеживает,
            // из-за этого счётчик людей и предупреждение «радиогид обязателен»
            // обновлялись через раз.
            const tickets = {}
            selectedMuseumObject.tickets.forEach(item => {
                tickets[item.internal_name] = 0
            })
            order.value.tickets = tickets

            const services = {}
            selectedMuseumObject.services.forEach(item => {
                services[item.internal_name] = false
            })

            // Аудиогид иностранным группам показываем и там, где его нет в
            // справочнике объекта. Ключ заводим сразу: добавленный позже Vue 2
            // не отследит, и галочка не отмечалась бы.
            if (order.value.type === 'en' && !('ag' in services)) services.ag = false
            order.value.services = services
            order.value.persons_per_guide = selectedMuseumObject.persons_per_guide
            order.value.system_id = selectedMuseumObject.system_id

            // Дата по умолчанию — самая ранняя допустимая для этого объекта,
            // иначе можно было бы взять время на сегодня, не открыв календарь.
            // Календарь пересоздаём уже с ней, иначе он показал бы прежнюю.
            order.value.date = earliestRequestDate(selectedMuseumObject)
            datepickerKey.value += 1
            order.value.schedule = null
            fetchSchedule()
            if (userData.use_default_data) {
            order.value.guideName = userData.default_guide_name
            order.value.guidePhone = userData.default_guide_phone

            // У китайской и российской группы страна зафиксирована — не
            // перетираем её страной по умолчанию из настроек клиента.
            if (!isChinaOrder.value && !isRuOrder.value) {
              order.value.country = getCountryByUserValue(selectedMuseumObject)
            }
            }
        })
    }

    const handleDateChanges = event => {
      order.value.date = event.date
      fetchSchedule()
    }

    // Галочка «хочу экскурсию в другой день»: пересобираем календарь (при включении
    // выходные объекта разблокируются) и сбрасываем выбор даты/времени — чтобы нельзя
    // было отправить закрытый день без пометки, сняв галочку постфактум.
    const onClosedDayToggle = () => {
      order.value.date = earliestRequestDate(store.getters['museumObjects/getSelectedMuseumObject'])
      order.value.schedule = null
      fetchSchedule()
      datepickerKey.value += 1
    }

    // Количество не может быть отрицательным или дробным. Правило у поля только
    // подсвечивает ошибку, но отправку не блокирует (кнопка «Отправить» с валидностью
    // формы не связана), поэтому подчищаем значения прямо перед отправкой.
    const toCount = value => String(Math.max(0, Math.trunc(Number(value) || 0)))

    const sendOrder = () => {
      order.value.guides = toCount(order.value.guides)
      Object.keys(order.value.tickets).forEach(key => {
        order.value.tickets[key] = toCount(order.value.tickets[key])
      })
      store.dispatch('createOrder/createOrder', order)
    }

    const closeMessageBoxAndRedirect = () => {
      store.commit('createOrder/close_message')
      router.push({ name: 'upcoming-requests' })
    }
    const closeMessageBox = () => {
      store.commit('createOrder/close_message')
    }
    store.commit('museumObjects/init_selected_museum_object')

    const updateKey = () => {
      rerenderKey.value += 1
    }

    const getFormatedLocale = () => {
        const locale = localStorage.getItem('locale') || 'ru'
        if (locale === 'zh') {
            return '_zh_cn'
        } if (locale === 'en') {
            return '_en_US'
        } if (locale === 'ru') {
            return '_ru_RU'
        } if (locale === 'fa') {
            return '_fa_IR'
        } if (locale === 'vi') {
            return '_vi'
        }

        return '_ru_RU'
    }

    // Тексты поля «кол-во гидов сопровождающих» правятся в админке у объекта
    // музея (с учётом языка). Пусто — вызывающий подставит текст по умолчанию.
    const guideFieldText = field => {
      const obj = store.getters['museumObjects/getSelectedMuseumObject'] || {}

      return obj[`${field}${getFormatedLocale()}`] || obj[field] || ''
    }

    // Сколько человек в группе — сумма всех видов билетов.
    const personsCount = computed(() => Object.values(order.value.tickets || {})
      .reduce((acc, value) => acc + Number(value || 0), 0))

    // Экскурсионное обслуживание (поле «гиды») — не вводится, а считается:
    // одно на группу до persons_per_guide человек (норма музея у объекта).
    const perGuide = computed(() => Number(order.value.persons_per_guide || 0))

    // Шеф, 23.10.2026: одно обслуживание на каждые persons_per_guide человек
    // с округлением вверх (40 человек при норме 15 — три); нормы нет — одно
    // на группу. Прежнее «всегда одно на заявку» (17.10.2026) отменено.
    watch([personsCount, perGuide], ([persons, norm]) => {
      order.value.guides = String(guideServicesCount(persons, norm))
    })

    // Подпись про норму («одно на каждые N человек») убрана 27.10.2026 по
    // просьбе начальника — клиенту это знать не нужно; остаётся только
    // подсказка из настроек объекта, если менеджер её задал.
    const autoGuidesHint = computed(() => guideFieldText('additional_guide_hint') || '')

    // Стоимость по прайс-листу (09.10.2026). Сервер ищет цену объекта в
    // прайсе клиента, иначе в общем; нет цены — строку не показываем.
    // Услуги без цены перечисляем отдельно, чтобы сумма не выглядела
    // окончательной. Пересчёт — с задержкой, пока человек печатает.
    const priceQuote = ref({ amount: null, missing: [] })
    let quoteTimer = null

    const serviceTitle = name => {
      if (name === 'guide') return root.$t('экскурсионное обслуживание')
      const found = serviceOptions.value.find(item => item.internal_name === name)
      if (!found) return name
      if (found.is_fallback) return 'Аудиогид'

      return found[`name${getFormatedLocale()}`] || found.name || name
    }

    const fetchPriceQuote = () => {
      if (!order.value.museumObject) {
        priceQuote.value = { amount: null, missing: [] }

        return
      }
      axios({
        method: 'post',
        url: '/api/v1/payments/price/',
        data: {
          system_id: order.value.museumObject,
          pass_date: order.value.date,
          tickets: order.value.tickets,
          services: order.value.services,
          group_type: order.value.type,
          school: order.value.school,

          // «Кол-во экскурсионного обслуживания» — у объекта своя цена за одно.
          qty_guide: order.value.guides,
        },
      })
        .then(response => {
          const result = response.data || {}
          if (!result.tickets_applicable) {
            priceQuote.value = { amount: null, missing: [] }

            return
          }
          priceQuote.value = {
            amount: Number(result.amount || 0),
            missing: (result.missing_services || []).map(serviceTitle),
          }
        })
        .catch(() => {
          priceQuote.value = { amount: null, missing: [] }
        })
    }

    watch(
      () => [
        order.value.museumObject,
        order.value.date,
        order.value.type,
        order.value.school,
        order.value.guides,
        JSON.stringify(order.value.tickets),
        JSON.stringify(order.value.services),
      ],
      () => {
        window.clearTimeout(quoteTimer)
        quoteTimer = window.setTimeout(fetchPriceQuote, 300)
      },
    )

    const formatMoney = value => `${new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 }).format(value)} ₽`

    // Радиогид обязателен: у объекта задан порог по числу туристов, и группа
    // до него дошла. Это ТОЛЬКО предупреждение — требование музея, а решает
    // клиент: заявку без радиогида и аудиогида отправить можно. Проверка,
    // которая не пускала дальше без отмеченной услуги, снята по просьбе
    // заказчика.
    const rgThreshold = computed(() => {
      const obj = store.getters['museumObjects/getSelectedMuseumObject'] || {}

      return Math.max(0, Number(obj.amount_for_rg) || 0)
    })
    const rgMandatory = computed(() => rgThreshold.value > 0 && personsCount.value >= rgThreshold.value)

    // поиск первой строкой в дропдаунах музея и страны
    const museumSearch = ref('')
    const countrySearch = ref('')

    const filteredMuseumsList = computed(() => {
      const list = store.getters['museums/getMuseumsList'] || []
      const query = (museumSearch.value || '').toLowerCase().trim()
      if (!query) return list
      const key = `name${getFormatedLocale()}`

      // выбранный музей оставляем в списке, чтобы селект не терял отображение
      return list.filter(
        museum => String(museum[key] || '').toLowerCase().includes(query)
          || museum.id === order.value.museum,
      )
    })

    const filteredCountries = computed(() => {
      const list = countriesOf(store.getters['museumObjects/getSelectedMuseumObject'])
      const query = (countrySearch.value || '').toLowerCase().trim()
      if (!query) return list

      return list.filter(
        country => String(country.name || '').toLowerCase().includes(query)
          || country.system_id === order.value.country,
      )
    })

    return {
      order,

      // Местная сегодняшняя дата: по ней прячем выбор времени для заявки «на
      // сегодня». Через UTC ночью сравнение шло со вчерашним днём.
      todayLocal: computed(() => toLocalDay()),
      multiRequest,
      isGroupMode,
      isGroupModeAllowed,
      isChinaOrder,
      isRuOrder,
      isForeignOrder,
      serviceOptions,
      isServiceDisabled,
      sameDayAllowed,
      onCategoryChange,
      guideFieldText,
      autoGuidesHint,
      rgThreshold,
      rgMandatory,
      personsCount,
      priceQuote,
      formatMoney,
      museumSearch,
      countrySearch,
      filteredMuseumsList,
      filteredCountries,
      orderForm,
      valid,
      activeStep,
      fetchMuseums,
      fetchMuseumObjects,
      fetchSchedule,
      setMuseumObject,
      sendOrder,
      handleDateChanges,
      onClosedDayToggle,
      closeMessageBoxAndRedirect,
      closeMessageBox,
      datepickerKey,
      validators: {
        required,
        integerPositiveValidator,
      },
      rerenderKey,
      updateKey,
      icons: {
        mdiCalendar,
        mdiHelpCircleOutline,
      },
      getFormatedLocale,

      // «Китайские туристы» — только клиентам с открытым китайским прайсом
      // (шеф, 30.10.2026); остальные подают китайскую группу как иностранную,
      // в китайском кабинете вместо неё — «иностранные туристы».
      typeList: computed(() => (localStorage.getItem('locale') === 'zh'
        ? {
            '_zh_cn': groupTypeChoices([{ name: '中国', value: 'cn' }], { name: '外国游客', value: 'en' }),
        }
        : {
            '_ru_RU': groupTypeChoices([
                { name: 'Российские туристы', value: 'ru' },
                { name: 'Иностранные туристы', value: 'en' },
                { name: 'Китайские туристы', value: 'cn' }]),
            '_en_US': groupTypeChoices([
                { name: 'Russian tourists', value: 'ru' },
                { name: 'Foreign tourists', value: 'en' },
                { name: 'Chinese tourists', value: 'cn' }]),
            '_fa_IR': groupTypeChoices([
                { name: 'توریست روسی', value: 'ru' },
                { name: 'گردشگران خارجی', value: 'en' },
                { name: 'گردشگران چینی', value: 'cn' }]),
            '_vi': groupTypeChoices([
                { name: 'Du khách Nga', value: 'ru' },
                { name: 'Du khách nước ngoài', value: 'en' },
                { name: 'Du khách Trung Quốc', value: 'cn' }]),
        })),
      museumsList: computed(() => store.getters['museums/getMuseumsList']),
      museumObjects: computed(() => store.getters['museumObjects/getMuseumObjectsList']),
      schedule: computed(() => store.getters['schedule/getSchedule'].filter(scheduleItem => !scheduleItem.name.includes('График'))),
      selectedMuseumObject: computed(() => store.getters['museumObjects/getSelectedMuseumObject']),
      isSending: computed(() => store.getters['createOrder/isSending']),
      isShowMessage: computed(() => store.getters['createOrder/isShowMessage']),
      successMsg: computed(() => store.getters['createOrder/successMsg']),
      errorMsg: computed(() => store.getters['createOrder/errorMsg']),
      isSuccess: computed(() => store.getters['createOrder/isSuccess']),
    }
  },
}
</script>
